import { TrustedDeviceRemoveCommand } from '@dreryk/egabinet-security-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, IconWrapper, RemoveIcon } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../../translations';

type TrustedDeviceRemoveParameters = {
   deviceId: number;
};

type DeviceRemoveIconProps = {
   readonly onRemoveSuccess: VoidFunction;
   readonly deviceId: number;
};

export const DeviceRemoveIcon = (props: DeviceRemoveIconProps): JSX.Element => {
   const { executeAsync: removeTrustedDevice } = useCqrsCommand<void, TrustedDeviceRemoveParameters>(
      (parameters) => {
         const command = new TrustedDeviceRemoveCommand();
         command.id = parameters.deviceId;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(mfaSettingsTranslationKeys.trustedDeviceTable.deviceRemovedSuccessfully);
            props.onRemoveSuccess();
         },
      }
   );
   return (
      <IconWrapper
         testId={'trustedDeviceRemove'}
         onClick={async () => removeTrustedDevice({ deviceId: props.deviceId })}
      >
         <RemoveIcon />
      </IconWrapper>
   );
};
